<template>
	<div class="remoteSensingpedia">
		<!--头部banner-->
		<!-- <div class="banner">
      <div class="bannerTitle">月球与行星科普教育资源库</div>
      <div class="bannerzn">
        LUNAR AND PLANETARY SCIENCE EDUCATION RESOURCE LIBRARY
      </div>
    </div> -->

		<!--主体-->
		<div class="main m-b-30">
			<div class="elbox">
				<el-row>
					<el-col :span="4">
						<div class="grid-content bg-purple">
							<div class="left">
								<div class="content">
									<div class="remoteSensingpedia">{{ $t('system.infoData.PopularScience') }}</div>
									<div class="menu">
										<el-menu :default-openeds="open_list" :default-active="activeItem" class="el-menu-vertical-demo" @select="handleSelect" @open="handleOpen" @close="handleClose">
											<div v-for="(father, fatherIndex) in menu" :key="fatherIndex">
												<el-submenu v-if="father.children" :index="father.id">
													<template slot="title">
														<i :class="father.icon"></i>
														<span>{{ language == 'en' ? father.enName : father.name }}</span>
													</template>
													<el-menu-item v-for="(item, i) in father.children" :key="i" :index="item.id">
														<span slot="title">{{ language == 'en' ? item.enName : item.name }}</span>
													</el-menu-item>
												</el-submenu>

												<el-menu-item v-else :index="father.id">
													<i :class="father.icon"></i>
													<span slot="title">{{ father.name }}</span>
												</el-menu-item>
											</div>
										</el-menu>
									</div>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="20" v-if="secdShow">
						<div class="grid-content bg-purple-light">
							<div class="right">
								<div class="content secd_Info">
									<div class="imgDivClass">
										<img style="background: #000" :src="imgServeUrl + secdInfo.image" alt="" width="800" height="650" v-if="secdInfo.image.indexOf('.mp4') == '-1'" />
										<video controls style="background: #000" v-else :src="imgServeUrl + secdInfo.image" alt="" width="800" height="650"></video>
										<div style="width: 42%">
											<ul>
												<li class="liClass" v-for="(item, index) in top4Arr" :key="index" @click="imgBtn(item)">
													<img style="background: #000" :src="imgServeUrl + item.image" alt="" v-if="item.image && item.image.indexOf('.mp4') == '-1'" />
													<video controls style="background: #000" v-else :src="imgServeUrl + item.image" alt="" width="180" height="120"></video>
													<div class="inforClass">
														<h3>{{ item.title }}</h3>
														<span>{{ $t('system.PopularScience.Producer') }}:{{ item.producer }}</span>
														<span>{{ $t('system.PopularScience.ViewCount') }}:{{ item.views }}</span>
													</div>
												</li>
											</ul>
										</div>
									</div>
									<div class="conDesc">
										<h4>{{ secdInfo.title }}</h4>
										<div>{{ $t('system.PopularScience.Producer') }}：{{ secdInfo.producer }}</div>
										<div>{{ $t('system.PopularScience.Description') }}：{{ secdInfo.desc }}</div>
										<div>{{ $t('system.PopularScience.ViewCount') }}：{{ secdInfo.views }}</div>
										<div>{{ $t('system.PopularScience.Time') }}：{{ secdInfo.createTime }}</div>
									</div>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="20" v-else>
						<div class="grid-content bg-purple-light">
							<div class="right" v-loading="loading" element-loading-text="数据加载中">
								<div v-if="!categoryFlag">
									<div class="content">
										<div style="font-size: 26px; color: #d6d6d6; cursor: pointer; float: right; display: block; margin-top: 0px">
											<i class="el-icon-picture-outline" @click="cameraPictureFunc(1)"></i>
											<!-- <i class="el-icon-picture"></i> -->
											<i class="el-icon-video-camera" @click="cameraPictureFunc(2)"></i>
											<!-- <i class="el-icon-video-camera-solid"></i> -->
										</div>
										<div style="display: flex; flex-wrap: wrap; margin-bottom: 16px">
											<span
												style="
													background-color: #0e5ca5;
													font-size: 14px !important;
													color: #fff;
													padding: 0px 10px;
													text-align: center;
													height: 40px;
													line-height: 40px;
													cursor: pointer;
													margin-right: 10px;
												"
												@click="allSelectedFunc()"
												>{{ $t('system.PopularScience.AllCategories') }}</span
											>
											<el-button
												v-for="(itemLoad, index) in loadTypeData"
												:key="index"
												:type="active == index ? 'primary' : ''"
												@click="loadBtn(itemLoad, index)"
												style="margin-bottom: 16px"
												>{{ language == 'en' ? itemLoad.enName : itemLoad.name }}</el-button
											>
										</div>

										<div style="display: flex; flex-wrap: wrap" v-if="infoList.length > 0">
											<div
												class="kpdx"
												v-for="(item, index) in infoList"
												:key="index"
												style="width: 24%; display: block; text-align: center"
												@click="selectIemScrd(item)"
												v-show="item.releaseStatus == 1"
											>
												<img style="background: #000" :src="imgServeUrl + item.image" alt="" width="300" height="280" v-if="item.image && item.image.indexOf('.mp4') == '-1'" />
												<video style="background: #000" v-else :src="imgServeUrl + item.image" alt="" width="300" height="280"></video>
												<div style="padding: 15px">
													<div style="text-align: left; font-size: 18px; font-weight: 700" class="title">{{ item.title }}</div>
													<div class="pro_ducer">{{ item.producer }}</div>
													<div style="display: flex">
														<div style="width: 50%; text-align: left">
															<!-- {{ item.loadName }}<i class="el-icon-view"></i> -->

															{{ $t('system.PopularScience.ViewCount') }}：{{ item.views }}
														</div>
														<div style="width: 50%; text-align: right">
															{{ item.productionTime }}
														</div>
													</div>
												</div>
												<div class="wg"></div>
											</div>
										</div>
										<el-empty v-else :image-size="200"></el-empty>
									</div>
									<div class="block" style="background-color: #fff; height: 50px; display: flex; justify-content: end; align-items: center">
										<el-pagination
											@size-change="handleSizeChange"
											@current-change="handleCurrentChange"
											:current-page="currentPage"
											:page-sizes="[8, 20, 50, 100]"
											:page-size="pageSize"
											background
											layout="total, sizes, prev, pager, next, jumper"
											:total="totalMoonSample"
										>
										</el-pagination>
									</div>
								</div>
								<div v-else>
									<div class="content">
										<div v-html="dataHtml" class="htmlContent"></div>
									</div>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'remoteSensingpedia',
	components: {},
	data() {
		return {
			language: localStorage.getItem('change-language'),
			typePicOrCamera: '',
			dataHtml: '',
			categoryFlag: false,
			active: -1,
			loadTypeData: [],
			top4Arr: [],
			currentPage: 1,
			pageSize: 8,
			totalMoonSample: 0,
			imgServeUrl: window.dataManage.imgDev,
			menu: [],

			open_list: ['Satelliteintroduction'],
			secdShow: false,
			secdInfo: {},
			info: {},
			infoList: [],
			activeItem: '-1'
		}
	},
	created() {},
	mounted() {
		this.getEncyclopediaofRemoteSensing(this.activeItem)
	},
	watch: {
		// activeItem(newValue) {
		//   this.getEncyclopediaofRemoteSensing(newValue)
		// }
	},
	methods: {
		cameraPictureFunc(type) {
			this.typePicOrCamera = type
			this.getListData()
		},
		allSelectedFunc() {
			this.typePicOrCamera = ''
			this.active = -1
			this.category = ''
			this.task = ''
			this.loadId = ''
			this.getListData()
		},
		loadBtn(itemLoad, index) {
			if (this.active == index) {
				this.active = -1
				this.category = ''
				this.task = ''
				this.loadId = ''
				this.getListData()
			} else {
				this.active = index
				this.loadId = itemLoad.id
				this.getListData()
			}
		},
		async getListData() {
			this.load = true
			let parms = {
				category: this.category,
				task: this.task,
				load: this.loadId,
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				type: this.typePicOrCamera
				// load:keyPath.length>2?keyPath[3]:'',
			}
			let info = await this.$http.get(this.$const.Platformconsulting.educationListUrl, parms)
			if (info.code === 200) {
				this.load = false
				this.infoList = info.rows
				this.totalMoonSample = info.total
			}
		},
		async getLoadDataFunc(key) {
			if (key != undefined) {
				let res = await this.$http.get(this.$const.Platformconsulting.getTypeData + `/${key}`)
				if (res.code === 200) {
					console.log(res)
					this.loadTypeData = res.data
				}
			}
		},
		imgBtn(item) {
			this.secdInfo = item
		},
		handleCurrentChange(val) {
			this.currentPage = val
			// this.getEncyclopediaofRemoteSensing()
			this.getListData()
		},
		handleSizeChange(val) {
			this.pageSize = val
			// this.getEncyclopediaofRemoteSensing()
			this.getListData()
		},
		//获取遥感百科
		async getEncyclopediaofRemoteSensing(type) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.sciencecategoryUrl)
				if (res.code === 200) {
					this.menu = [
						{
							id: '-1',
							name: this.$t('system.PopularScience.AllCategories'),
							icon: 'el-icon-s-comment'
						}
					]
					res.data.forEach((element, j) => {
						// element.id=  element.id.toString()
						this.menu.push(element)
					})
					console.log(this.menu)
					let resData = await this.$http.get(this.$const.Platformconsulting.getEducationQuteList)
					if (resData.code === 200) {
						console.log(resData)
						this.menu.push({
							id: 20,
							name: this.$t('system.PopularScience.DataIndex'),
							enName: this.$t('system.PopularScience.DataIndex'),
							icon: 'el-icon-s-comment',
							children: [
								{
									id: 21,
									name: resData.data[0].title,
									enName: resData.data[0].title
								},
								{
									id: 22,
									name: resData.data[1].title,
									enName: resData.data[1].title
								}
							]
						})
					}
					this.handleSelect('-1', ['-1'])
				}
			} catch (e) {
				console.log(e)
			}
		},
		async selectIemScrd(item) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.educationDeseURl + item.explainId)
				if (res.code === 200) {
					this.secdInfo = res.data
					this.secdShow = true
					this.getTop4InfoData()
				}
			} catch (e) {
				console.log(e)
			}
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath)
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath)
		},

		async getEducationQuteListFunc(key) {
			let resData = await this.$http.get(this.$const.Platformconsulting.getEducationQuteList)
			if (resData.code === 200) {
				if (key == 21) {
					this.dataHtml = resData.data[0].content
				} else {
					this.dataHtml = resData.data[1].content
				}
			}
		},
		async handleSelect(key, keyPath) {
			console.log(key, keyPath)
			this.categoryFlag = false
			if (keyPath[0] == 20 || keyPath[0] == 21 || keyPath[0] == 22) {
				this.categoryFlag = true
				this.getEducationQuteListFunc(key)
			} else {
				this.getLoadDataFunc(keyPath[1])
				this.secdShow = false
				this.category = key == '-1' ? '' : keyPath[0]
				this.task = keyPath.length > 1 ? keyPath[1] : ''
				this.getListData()
			}
		},
		async getTop4InfoData() {
			let resData = await this.$http.get(this.$const.Platformconsulting.top4EducationList)
			if (resData.code === 200) {
				this.top4Arr = resData.data
			}
		}
	}
}
</script>

<style lang="scss" scoped>
$height: 1000px;
.remoteSensingpedia {
	.banner {
		width: 100%;
		min-width: 1200px;
		height: 25vh;
		background: url('~@/assets/imgs/remoteSensingpedia/lunar _rover_banner.png') no-repeat;
		background-size: 100% 100%;
		background-position: center;
		.bannerTitle {
			width: 80%;
			margin: 0 auto;
			padding-top: 3%;
			line-height: 60px;
			font-size: 28px;
			color: #f5f5f5;
		}
		.bannerzn {
			width: 80%;
			margin: 0 auto;
			line-height: 40px;
			font-size: 22px;
			color: #f5f5f5;
		}
	}

	.main {
		// margin-top: -50px;

		.elbox {
			margin: 0 auto;
			width: 100%;

			.left {
				width: 100%;
				padding: 0 0 0 50px;

				.content {
					width: 100%;
					height: $height;
					background: #fff;
					border: 1px solid #dde4ea;

					.menu {
						height: calc(100% - 50px);
						overflow-y: auto;
						scrollbar-width: none; /* firefox */
						-ms-overflow-style: none; /* IE 10+ */
						&::-webkit-scrollbar {
							/* Chrome Safari */
							display: none;
						}
					}

					.el-menu {
						border-right: none;

						li.el-menu-item.is-active::before {
							display: inline-block;
							content: '';
							width: 5px;
							height: 15px;
							background: #3867e9;
							position: absolute;
							top: 0;
							bottom: 0;
							margin: auto;
							left: 0;
						}
					}

					.remoteSensingpedia {
						padding-left: 40px;
						height: 50px;
						line-height: 50px;
						font-size: 20px;
						font-weight: bold;
					}

					ul.remoteSensingpedia_item {
						overflow: hidden;
					}
				}
			}

			.right {
				width: 100%;
				padding: 0 50px 0 20px;
				.content:after {
					content: ' ';
					width: 24%; //这个宽度和子元素宽度一致
					height: 0;
					display: block;
				}
				.content {
					width: 100%;
					height: $height;
					background: #fff;
					margin: 0 auto;
					border: 1px solid #dde4ea;
					padding: 25px;
					overflow-y: auto;
					scrollbar-width: none; /* firefox */
					-ms-overflow-style: none; /* IE 10+ */

					&::-webkit-scrollbar {
						/* Chrome Safari */
						display: none;
					}
					.kpdx {
						cursor: pointer;
						position: relative;
						border: 1px solid #f1f1f1;
						.title {
							white-space: nowrap; /* 防止文本换行 */
							overflow: hidden; /* 隐藏溢出的内容 */
							text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
						}
						.pro_ducer {
							margin: 10px 0;
							width: 120px;
							height: 30px;
							line-height: 30px;
							text-align: center;
							font-family: ReeJi-BigRuixain, ReeJi-BigRuixain;
							font-weight: normal;
							font-size: 14px;
							color: #ffffff;
							background: url('~@/assets/imgs/remoteSensingpedia/jx.png') no-repeat;
							background-size: 100% 100%;
							background-position: center;
						}
						.wg {
							width: 150px;
							height: 150px;
							position: absolute;
							right: 0;
							bottom: 0;
							background: url('~@/assets/imgs/remoteSensingpedia/wg.png') no-repeat;
							background-size: 100% 100%;
							background-position: center;
						}
					}
					.kpdx:hover {
						background: rgba(21, 65, 140, 0.08);
					}

					// div:nth-child(1) {
					//   // text-align: center;
					//   font-size: 22px;
					//   font-weight: 400;
					//   margin-bottom: 30px;
					// }
				}
			}
		}
	}
}
.secd_Info {
	.imgDivClass {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		.liClass {
			display: flex;
			margin-bottom: 16px;
			img {
				width: 180px;
				height: 120px;
			}
			.inforClass {
				display: flex;
				text-align: left;
				flex-direction: column;
				loat: left;
				background-color: #fff;
				width: 500px;
				height: 120px;
				padding: 10px 10px 0 10px;
				border: 1px solid rgb(145, 149, 152);
			}
		}
	}
}
:hover.el-icon-picture-outline,
:hover.el-icon-video-camera {
	color: #3867e9;
}
</style>
<style>
.htmlContent p img {
	width: 100%;
}
.htmlContent p {
	font-family: '宋体' !important;
	line-height: 30px;
	text-indent: 2rem;
}
.htmlContent p span {
	font-family: '宋体' !important;
	line-height: 30px;
	text-indent: 2rem;
}
</style>